import {
	Component,
	EventEmitter,
	Input,
	Output
} from '@angular/core';

@Component( {
	selector: 'app-option-filter-item',
	templateUrl: './option-filter-item.component.html',
	styleUrls: [ './option-filter-item.component.scss' ]
} )
export class OptionFilterItemComponent {

	@Input() label: string;

	@Input() index: number;

	@Input() isActive: boolean;

	@Output() optionFilterItemEmitter: EventEmitter<number> = new EventEmitter();

	onOptionFilterItemClick() {
		if ( this.isActive ) { return; }
		this.optionFilterItemEmitter.emit( this.index );
	}
}
